import { render, staticRenderFns } from "./ClassificacaoCriar.vue?vue&type=template&id=ccfd7f86"
import script from "./ClassificacaoCriar.vue?vue&type=script&lang=js"
export * from "./ClassificacaoCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports